import React, { useMemo } from "react";

import Loading from "../../Common/Loading";
import NoResultsGIF from "../../Common/NoResultsGIF";
import StyledScrollbar from "../../Common/UIComponents/StyledScrollbar";
import RequestTableRow from "./RequestTableRow";

import pumpkinGIF from "../../../assets/images/environment/pumpkin.gif";
import "./RequestTable.css";

const getRowKey = (row, idx) => row.supply_order_id ?? row.pickup_order_id ?? idx;

export default function RequestTable({
  tableData = [],
  columns = [],
  actionMap,
  onRowClick,
  onCreateEditClick,
  onSpInstructionClick,
  onDeleteClick,
  onPrintLabelClick,
  onDownloadLabelClick,
  onViewOrderSummaryClick,
  loading,
  loadingNewContent = false,
  paginationInfo,
  fetchRequests,
  scrollbarRef,
  search = "",
  onScroll,
}) {
  const highlightWords = useMemo(
    () => search.trim().split(/\s+/).filter(Boolean),
    [search],
  );

  const handleScrollToBottom = (e) => {
    const handlePageChangeScroll = () => {
      const {
        nextPageLink, currentPage, totalPages,
      } = paginationInfo;
      const isLastPage = parseInt(currentPage, 10) === parseInt(totalPages, 10);

      if (!isLastPage && !loadingNewContent && !loading) {
        const nextPage = nextPageLink
          ? nextPageLink.split("page=")[1].split("&")[0]
          : String(parseInt(currentPage, 10) + 1);
        fetchRequests({ page: nextPage });
      }
    };

    const tolerance = 3;
    const bottom = Math.abs(Math.ceil(e.contentScrollHeight - e.scrollTop) - Math.ceil(e.clientHeight)) <= tolerance;
    if (bottom) {
      handlePageChangeScroll();
    }
  };

  return (
    <div className="RequestTableDiv">

      <StyledScrollbar
        ref={scrollbarRef}
        disableTrackYWidthCompensation
        disableTracksWidthCompensation
        onScroll={onScroll}
        onScrollStop={(e) => handleScrollToBottom(e)}
      >
        <div className="RequestTableWrapper">
          <table>
            <thead className="RequestTable__Header">
              <tr>
                {columns.map((column, idx) => (
                  <th key={idx}>
                    {column.header ? column.header : column.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {!loading && tableData.map((row, idx) => (
                <RequestTableRow
                  key={getRowKey(row, idx)}
                  row={row}
                  columns={columns}
                  actionMap={actionMap}
                  onRowClick={onRowClick}
                  onCreateEditClick={onCreateEditClick}
                  onDeleteClick={onDeleteClick}
                  onSpInstructionClick={onSpInstructionClick}
                  onPrintLabelClick={onPrintLabelClick}
                  onDownloadLabelClick={onDownloadLabelClick}
                  onViewOrderSummaryClick={onViewOrderSummaryClick}
                  highlightWords={highlightWords}
                />
              ))}
            </tbody>
          </table>
          {loading && (<div className="RequestTableLoading ActiveloadingAnimation" />)}
        </div>
        {!loading && tableData.length === 0 && (<NoResultsGIF image={pumpkinGIF} message="No Data" />)}
        {!loading && loadingNewContent && tableData.length > 0 && <Loading />}
      </StyledScrollbar>
    </div>
  );
}
